module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!doctype html>\n<html lang="en">\n  <head>\n    <meta charset="utf-8">\n    <meta http-equiv="X-UA-Compatible" content="IE=edge">\n    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no" />\n    <meta property="fullbleed" content="' +
((__t = ( htmlWebpackPlugin.options.isFullbleed )) == null ? '' : __t) +
'" />\n    <meta property="slug" content="' +
((__t = ( htmlWebpackPlugin.options.project.slug )) == null ? '' : __t) +
'" />\n    <title>' +
((__t = ( htmlWebpackPlugin.options.title )) == null ? '' : __t) +
'</title>\n\n  </head>\n  <body>\n    <div class="chart-container">\n      <h2 class="headline">Change in rent from February 2020 to June 2021</h2>\n      <h3 class="headline-units">Average rent for 101 US metro areas, seasonally adjusted</h3>\n      <div class="chart"></div>\n      <p class="source">Guardian graphic. Source: Zillow</p>\n    </div>\n  </body>\n\n</html>\n<script src="https://interactive.guim.co.uk/libs/iframe-messenger/iframeMessenger.js" type="text/javascript"></script>\n\n<script>iframeMessenger.enableAutoResize()</script>\n\n';

}
return __p
}